import { render } from "./CreateRelationModal.vue?vue&type=template&id=61229422"
import script from "./CreateRelationModal.vue?vue&type=script&lang=js"
export * from "./CreateRelationModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__